(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mini-cart"]) return;
  try {
    
  if (!customElements.get('cart-announcement-bar')) {
    class CartAnnouncementBar extends HTMLElement {
      connectedCallback() {
        this.text = this.querySelector('.cart-announcement-bar__text');
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this);
        this.update();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      update() {
        const style = getComputedStyle(this);
        const availableWidth = this.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);

        this.classList.remove('is-scrolling');
        const textWidth = this.text.scrollWidth;

        if (textWidth > availableWidth) {
          this.style.setProperty('--cart-announcement-duration', `${Math.max(textWidth / 40, 8)}s`);
          this.classList.add('is-scrolling');
        }
      }
    }

    customElements.define('cart-announcement-bar', CartAnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-box"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const tabBox = document.querySelector('.tab-box');
  const tabLinks = tabBox.querySelectorAll('.tab-link');
  const tabContents = tabBox.querySelectorAll('.tab-content');

  tabLinks.forEach(link => {
    link.addEventListener('click', () => {
      const target = link.getAttribute('data-tab');

      tabLinks.forEach(btn => btn.classList.remove('active'));
      tabContents.forEach(content => content.classList.remove('active'));

      link.classList.add('active');
      tabBox.querySelector('#' + target).classList.add('active');
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
